/**
 *
 * ResultTeamTable
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "redux"
import ResultTableByTeam from "../../../../components/ResultTableByTeam"

/* eslint-disable react/prefer-stateless-function */
export class ResultTeamTable extends React.Component {
  render() {
    const {
      data,
      isLoading,
      match,
      showVariation,
      measureColorRange,
    } = this.props

    return (
      <ResultTableByTeam
        match={match}
        data={data}
        isLoading={isLoading}
        showVariation={showVariation}
        measureColorRange={measureColorRange}
      />
    )
  }
}

ResultTeamTable.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

function mapDispatchToProps(dispatch) {
  return { dispatch }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(ResultTeamTable)
